import { render, staticRenderFns } from "./UsersControl.vue?vue&type=template&id=13f52a47&scoped=true"
import script from "./UsersControl.vue?vue&type=script&lang=js"
export * from "./UsersControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f52a47",
  null
  
)

export default component.exports